<template>
  <div>
    <div>
      <span class="pull-left">{{ optionItem.name }}</span>
    </div>
    <core-goods-field :optionItem="optionItem" class="clearfix"/>
  </div>
</template>
<script>
  export default {
    name: 'manageGoodsOption',
    props: {
      optionItem: {
        required: true,
        type: Object
      }
    }
  };
</script>
